interface LabFloLogoProps {
    size?: number;
    className?: string;
}

export default function LabFloLogo({ size = 40, className = "" }: LabFloLogoProps) {
    return (
        <svg 
            width={size} 
            height={size} 
            viewBox="0 0 48 48" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            {/* Background circle */}
            <rect width="48" height="48" rx="12" fill="url(#gradient)" />
            
            {/* Flask shape */}
            <path 
                d="M20 12V18L14 30C13.2 31.6 14.4 34 16.2 34H31.8C33.6 34 34.8 31.6 34 30L28 18V12" 
                stroke="white" 
                strokeWidth="2.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
                fill="none"
            />
            
            {/* Flask top */}
            <path 
                d="M18 12H30" 
                stroke="white" 
                strokeWidth="2.5" 
                strokeLinecap="round"
            />
            
            {/* Flow wave inside flask */}
            <path 
                d="M16 26C18 24 20 28 22 26C24 24 26 28 28 26C30 24 32 28 32 26" 
                stroke="rgba(255,255,255,0.7)" 
                strokeWidth="2" 
                strokeLinecap="round"
                fill="none"
            />
            
            {/* Sparkle/sterile dot */}
            <circle cx="32" cy="16" r="2" fill="white" opacity="0.9" />
            
            {/* Gradient definition */}
            <defs>
                <linearGradient id="gradient" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#7C3AED" />
                    <stop offset="1" stopColor="#5B21B6" />
                </linearGradient>
            </defs>
        </svg>
    );
}
